<template>
	<div class="content">
		<div class="La-footer">
			<div class="La-footer-main">
				<div class="La-footer-main-logo" @click="SelectHome()">
					<img src="../assets/home-image/fooderlogo.png" />
					<p class="La-footer-box-shu">|</p>
				</div>
				<div class="La-footer-main-ul">
					<div class="La-footer-main-ul-p">
						<p @click="SelectHome()">首页</p>
						<p @click="SelectProduct()">产品及服务</p>
						<p @click="SelectAbout()">关于我们</p>
						<p @click="SelectActivity()">最新活动</p>
						<p @click="SelectTeam()">合作案例</p>
						<p @click="SelectNews()">新闻中心</p>
					</div>
					<div class="La-footer-main-ul-w">
						<div class="La-footer-box">
							<img src="../assets/home-image/weixinnamber.png" />
							<span>官方微信</span>
						</div>
						<div class="clear"></div>
						<div class="La-footer-box-email">
							<p>E-mail：bd@nowyousee.cn</p>
						</div>
					</div>
				</div>
				<div class="La-footer-main-con">
					<div class="La-footer-main-con-c">
						<div class="La-footer-main-con-c-up">
							<p>
								深圳总部 联系电话：待定
							</p>
							<p>
								地址：深圳市福田区彩田路3002号小元里商务办公空间3楼
							</p>
							<p>
								联系电话：待定
							</p>
						</div>
						<div class="La-footer-main-con-c-dwon">
							<p>
								上海分公司
							</p>
							<p>
								地址：上海市浦东新区长青路1200弄36号815-817室
							</p>
							<p>
								联系电话：021-50770206
							</p>
						</div>
					</div>
				</div>
				<div class="La-footer-main-down">
					©2020深圳即刻优势教育科技有限公司 沪ICP备15037860号-6
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FooderContent',
    methods: {
    	/* 首页跳转 */
    	SelectHome() {
    		this.$router.push({
    			path: '/Home'
    		})
    	},
    	/* 最新活动 */
    	SelectActivity() {
    		this.$router.push({
    			path: '/Latevents'
    		})
    	},
    	/* 产品及服务 */
    	SelectProduct() {
    		this.$router.push({
    			path: '/Productservices'
    		})
    	},
    	/* 合作方案 */
    	SelectTeam() {
    		this.$router.push({
    			path: '/Cooperaprog'
    		})
    	},
    	/* 关于我们 */
    	SelectAbout() {
    		this.$router.push({
    			path: '/Aboutus'
    		})
    	},
    	/* 点击跳转新闻中心 */
    	SelectNews() {
    		console.log(this.$router)
    		this.$router.push({
    			name: 'NewsCenter'
    		})
    	},
    	/* 联系我们 */
    	SelectContact() {
    		this.$router.push({
    			path: '/Contactus'
    		})
    	}
    }
	}
</script>

<style>
	.La-footer {
		width: 100%;
		display: inline-block;
		max-width: 100%;
		height: auto;
		min-width: 118rem;
		height: 25rem;
		background-color: #000
	}

	.La-footer-main {
		width: 85%;
		min-width: 90%;
		height: 25rem;
		margin: 0 auto
	}

	.La-footer-main-logo {
		width: 18%;
		height: 4.6875rem;
		float: left;
		margin-left: 80px;
		margin-top: 150px
	}

	.La-footer-main-logo img {
		margin-top: 14px
	}

	.La-footer-main-ul {
		width: 36%;
		height: 15rem;
		float: left;
		margin-left: 10px;
		margin-top: 100px
	}

	.La-footer-main-ul-p {
		width: 80%;
		height: 10rem;
		overflow: auto;
		margin: 0 auto
	}

	.La-footer-main-ul-p p {
		width: 33.333% !important;
		height: 1.5rem;
		float: left;
		font-size: 18px;
		font-family: Source Han Sans SC;
		margin-top: 1.875rem;
		color: #fff
	}

	.La-footer-main-ul-w {
		width: 83%;
		height: 5rem;
		overflow: auto;
		margin: 0 auto
	}

	.La-footer-box {
		width: 8.375rem;
		height: 2.1875rem;
		font-size: 1.125rem;
		font-family: Source Han Sans SC;
		background-color: #fff;
		border-radius: .3125rem;
		color: #2d2d2d;
		float: left
	}

	.La-footer-box-shu {
		width: 0;
		height: 75px;
		border: 1px solid #fff;
		opacity: .41;
		position: relative;
		top: -65px;
		left: 305px
	}

	.La-footer-box img {
		width: 1.62875rem;
		height: 1.331875rem;
		margin-left: .625rem;
		margin-top: .4375rem;
		margin-bottom: .4375rem
	}

	.La-footer-box span {
		height: 100%;
		line-height: 2.1875rem;
		margin-right: 1rem;
		float: right
	}

	.clear {
		clear: both
	}

	.La-footer-box-email {
		width: 15.625rem;
		height: 2.1875rem;
		margin-left: 3.5rem;
		position: relative;
		top: -35px;
		left: 96px
	}

	.La-footer-box-email p {
		overflow: auto;
		font-size: 1rem;
		font-family: Source Han Sans SC;
		margin: 0 !important;
		padding-top: 6px;
		color: #fff
	}

	.La-footer-main-con {
		width: 40%;
		height: 15rem;
		float: left;
		margin-top: 100px
	}

	.La-footer-main-con-c {
		width: 90%;
		min-width: 750px;
		height: 15rem;
		margin: 0 auto
	}

	.La-footer-main-con-c-up {
		width: 100%;
		min-width: 750px;
		height: 7rem
	}

	.La-footer-main-con-c-up p {
		color: #fff;
		font-size: 17px;
		padding: 2px 0
	}

	.La-footer-main-con-c-dwon {
		width: 100%;
		min-width: 750px;
		height: 7rem
	}

	.La-footer-main-con-c-dwon p {
		color: #fff;
		font-size: 17px;
		padding: 2px 0
	}

	.La-footer-main-down {
		width: 100%;
		min-width: 1000px;
		height: 2rem;
		overflow: hidden;
		text-align: center;
		color: #fff
	}

	/* @media (min-device-width: 1000px) {
	    .La-footer{ height: 25rem; width: 100%;}
	} */

	@media screen and (max-width: 100rem) {
		.La-footer {
			width: 100%;
			display: inline-block;
			max-width: 100%;
			height: auto;
			min-width: 118rem;
			min-height: 100%;
			max-height: 100%;
			height: 25rem;
			background-color: #000
		}

		.La-footer-main {
			width: 85%;
			min-width: 100%;
			height: 25rem;
			margin: 0 auto
		}

		.La-footer-main-logo {
			width: 18%;
			height: 4.6875rem;
			float: left;
			margin-left: 80px;
			margin-top: 150px
		}

		.La-footer-box-shu {
			width: 0;
			height: 75px;
			border: 1px solid #fff;
			opacity: .41;
			position: relative;
			top: -65px;
			left: 305px
		}

		.La-footer-main-ul {
			width: 36%;
			height: 15rem;
			float: left;
			margin-left: 10px;
			margin-top: 100px
		}

		.La-footer-main-ul-p {
			width: 80%;
			height: 10rem;
			overflow: auto;
			margin: 0 auto
		}

		.La-footer-main-ul-p p {
			width: 33.333% !important;
			height: 1.5rem;
			float: left;
			font-size: 18px;
			font-family: Source Han Sans SC;
			margin-top: 1.875rem;
			color: #fff
		}

		.La-footer-main-ul-w {
			width: 83%;
			height: 5rem;
			overflow: auto;
			margin: 0 auto
		}

		.La-footer-box {
			width: 8.375rem;
			height: 2.1875rem;
			font-size: 1.125rem;
			font-family: Source Han Sans SC;
			background-color: #fff;
			border-radius: .3125rem;
			color: #2d2d2d;
			float: left
		}

		.La-footer-box img {
			width: 1.62875rem;
			height: 1.331875rem;
			margin-left: .625rem;
			margin-top: .4375rem;
			margin-bottom: .4375rem
		}

		.La-footer-box span {
			height: 100%;
			line-height: 2.1875rem;
			margin-right: 1rem;
			float: right
		}

		.La-footer-box-email {
			width: 15.625rem;
			height: 2.1875rem;
			margin-left: 3.5rem;
			position: relative;
			top: -35px;
			left: 96px
		}

		.La-footer-box-email p {
			overflow: auto;
			font-size: 1rem;
			font-family: Source Han Sans SC;
			margin: 0 !important;
			padding-top: 6px;
			color: #fff
		}

		.La-footer-main-con {
			width: 40%;
			height: 15rem;
			float: left;
			margin-top: 100px
		}

		.La-footer-main-con-c {
			width: 90%;
			min-width: 750px;
			height: 15rem;
			margin: 0 auto
		}

		.La-footer-main-con-c-up {
			width: 100%;
			min-width: 750px;
			height: 7rem
		}

		.La-footer-main-con-c-up p {
			color: #fff;
			font-size: 17px;
			padding: 2px 0
		}

		.La-footer-main-con-c-dwon {
			width: 100%;
			min-width: 750px;
			height: 7rem
		}

		.La-footer-main-con-c-dwon p {
			color: #fff;
			font-size: 17px;
			padding: 2px 0
		}

		.La-footer-main-down {
			width: 100%;
			min-width: 1000px;
			height: 2rem;
			overflow: hidden;
			text-align: center;
			color: #fff
		}
	}
	@media screen and (max-width: 62rem) {
		.La-footer {
			width: 100%;
			display: inline-block;
			max-width: 20rem;
			min-width: 100%;
			height: 40rem
		}

		.La-footer-main {
			width: 100%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 25rem;
			margin: 0 auto
		}

		.La-footer-main-logo {
			width: 40%;
			height: 4.6875rem;
			float: left;
			margin-left: 80px;
			margin-top: 15px
		}

		.La-footer-box-shu {
			width: 0;
			height: 75px;
			border: 1px solid #fff;
			opacity: .41;
			position: relative;
			top: -65px;
			left: 305px;
			display: none
		}

		.La-footer-main-ul {
			width: 100%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 15rem;
			margin-left: 10px;
			margin-top: 10px
		}

		.La-footer-main-ul-p {
			width: 100%;
			height: 10rem;
			overflow: auto;
			margin: 0 auto;
			padding-right: 35px
		}

		.La-footer-main-ul-p p {
			width: 33.333% !important;
			height: .5rem;
			float: left;
			font-size: 17px;
			font-family: Source Han Sans SC;
			margin-top: 1.875rem;
			color: #fff
		}

		.La-footer-main-ul-w {
			width: 100%;
			height: 5rem;
			overflow: auto
		}

		.La-footer-box {
			width: 6.375rem;
			height: 2.1875rem;
			font-family: Source Han Sans SC;
			background-color: #fff;
			border-radius: .3125rem;
			color: #2d2d2d;
			float: left
		}

		.La-footer-box img {
			width: 1.62875rem;
			height: 1.331875rem;
			margin-left: .35rem;
			margin-top: .475rem;
			margin-bottom: .3375rem
		}

		.La-footer-box span {
			height: 100%;
			line-height: 2.1875rem;
			margin-right: 10px;
			float: right;
			font-size: 14px
		}

		.La-footer-box-email {
			width: 15.625rem;
			height: 2.1875rem;
			margin-left: 1.5rem;
			position: relative;
			top: -35px;
			left: 96px
		}

		.La-footer-box-email p {
			overflow: auto;
			font-size: 14px;
			font-family: Source Han Sans SC;
			margin: 0 !important;
			padding-top: 6px;
			color: #fff
		}

		.La-footer-main-con {
			width: 101%;
			height: 15rem;
			margin-top: 10px;
			margin-left: 10px
		}

		.La-footer-main-con-c {
			width: 90%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 15rem;
			margin: 0 auto
		}

		.La-footer-main-con-c-up {
			width: 100%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 7rem
		}

		.La-footer-main-con-c-up p {
			color: #fff;
			font-size: 13px;
			padding: 2px 0
		}

		.La-footer-main-con-c-dwon {
			width: 100%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 7rem
		}

		.La-footer-main-con-c-dwon p {
			color: #fff;
			font-size: 13px;
			padding: 2px 0
		}

		.La-footer-main-down {
			width: 100%;
			max-width: 20rem;
			min-width: 23.2rem;
			height: 2rem;
			overflow: hidden;
			text-align: left;
			color: #fff;
			margin-left: 14px;
			font-size: 12px
		}
	}
	@media screen and (max-width: 48rem) {
		.La-footer {
			width: 100%;
			display: inline-block;
			max-width: 20rem;
			min-width: 100%;
			height: 40rem
		}

		.La-footer-main {
			width: 100%;
			max-width: 20rem;
			min-width: 19.2rem;
			height: 25rem;
			margin: 0 auto
		}

		.La-footer-main-logo {
			width: 40%;
			height: 4.6875rem;
			float: left;
			margin-left: 80px;
			margin-top: 15px
		}

		.La-footer-box-shu {
			width: 0;
			height: 75px;
			border: 1px solid #fff;
			opacity: .41;
			position: relative;
			top: -65px;
			left: 305px;
			display: none
		}

		.La-footer-main-ul {
			width: 100%;
			max-width: 15rem;
			min-width: 19.2rem;
			height: 15rem;
			margin-left: 10px;
			margin-top: 10px
		}

		.La-footer-main-ul-p {
			width: 90%;
			height: 10rem;
			overflow: auto;
			margin: 0 auto;
			padding-right: 0
		}

		.La-footer-main-ul-p p {
			width: 33.333% !important;
			height: .5rem;
			float: left;
			font-size: 13px;
			font-family: Source Han Sans SC;
			margin-top: 1.875rem;
			color: #fff
		}

		.La-footer-main-ul-w {
			width: 100%;
			height: 5rem;
			overflow: auto
		}

		.La-footer-box {
			width: 6.375rem;
			height: 2.1875rem;
			font-family: Source Han Sans SC;
			background-color: #fff;
			border-radius: .3125rem;
			color: #2d2d2d;
			float: left
		}

		.La-footer-box img {
			width: 1.62875rem;
			height: 1.331875rem;
			margin-left: .25rem;
			margin-top: .3375rem;
			margin-bottom: .3375rem
		}

		.La-footer-box span {
			height: 100%;
			line-height: 2.1875rem;
			margin-right: 10px;
			float: right;
			font-size: 14px
		}

		.La-footer-box-email {
			width: 11.5rem;
			height: 2.1875rem;
			margin-left: 1.5rem;
			position: relative;
			top: -35px;
			left: 96px
		}

		.La-footer-box-email p {
			overflow: auto;
			font-size: 13.5px;
			font-family: Source Han Sans SC;
			margin: 0 !important;
			padding-top: 6px;
			color: #fff
		}

		.La-footer-main-con {
			width: 84%;
			height: 15rem;
			margin-top: 10px;
			margin-left: 10px
		}

		.La-footer-main-con-c {
			width: 80%;
			max-width: 19rem;
			min-width: 19.2rem;
			height: 15rem;
			margin: 0 auto
		}

		.La-footer-main-con-c-up {
			width: 93%;
			max-width: 19rem;
			min-width: 19.2rem;
			height: 7rem
		}

		.La-footer-main-con-c-up p {
			color: #fff;
			font-size: 13px;
			padding: 2px 0
		}

		.La-footer-main-con-c-dwon {
			width: 90%;
			max-width: 19rem;
			min-width: 15.2rem;
			height: 7rem
		}

		.La-footer-main-con-c-dwon p {
			color: #fff;
			font-size: 13px;
			padding: 2px 0
		}

		.La-footer-main-down {
			width: 100%;
			max-width: 19rem;
			min-width: 19.2rem;
			height: 2rem;
			overflow: hidden;
			text-align: left;
			color: #fff;
			margin-left: 14px;
			font-size: 12px
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/fooder.vue